import React, { useCallback, useEffect, useState } from "react";
import { getPoibyCityIdAndServiceId } from "../Services/citiesApi";
import { FaBars, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import StreetMapContainer  from "./StreetMapContainer";
import useAutoThemeLock from "../hook/useAutoThemeLock";
const ServiceViewModal = ({ isOpen, close, url, isMap,services ,terminalData,poiCategories}) => {
  const cityId = terminalData?.cityId ?? 1;
  const [isLoading, setIsLoading] = useState(true);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [map, setMap] = useState([]);
    useAutoThemeLock();

    const { t } = useTranslation();
  
  const getPoiForTerminal = useCallback(
    async (cityId, categoryId = null) => {
      if (!services?.length) return;

      const poiService = services.find(
        (s) => s.serviceType === "Points of Interests"
      );

      if (!poiService) return;

      const {data} = await getPoibyCityIdAndServiceId(
        cityId,
        poiService.serviceTypeId,
        categoryId,
      );
      if(data?.status){
        setMap(Array.isArray(data?.data) ? data?.data : [])
      }

    },
    [services]
  );



  useEffect(() => {
    if (cityId) {
      getPoiForTerminal(cityId, selectedCategory);
    }
  }, [cityId, getPoiForTerminal, selectedCategory]);

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      // Small delay to ensure map container is rendered before initializing
      if (isMap) {
        setTimeout(() => setIsLoading(false), 100);
      }
    }
  
  }, [isOpen, isMap]);

  const handleCategorySelection = (categoryId) => {
    // Single select: if same category clicked, deselect it; otherwise select new one
    setSelectedCategory(prev => prev === categoryId ? null : categoryId);
  };

  const handleCategoryClick = (categoryId) => {
    // When any category is clicked, ensure panel is open
    if (!isPanelOpen) {
      setIsPanelOpen(true);
    }
    // Toggle selection when clicking on the category item
    handleCategorySelection(categoryId);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg shadow-lg w-[90vw] h-[80vh] flex flex-col overflow-hidden">
        <button
          onClick={close}
          className="absolute top-2 right-2 z-[1000] text-gray-500 hover:text-gray-800 bg-white rounded-full p-1 shadow-md"
        >
          ✕
        </button>
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-[999]">
            <div className="loader animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-600"></div>
          </div>
        )}
        {isMap ? (
          <div className="w-full h-full relative" style={{ paddingTop: '80px', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
            {/* Toggle Button for Left Panel */}
            {!isPanelOpen?
            <button
              onClick={() => setIsPanelOpen(!isPanelOpen)}
              className="absolute top-8 left-10 z-[1001] bg-white rounded-lg shadow-lg p-3 hover:bg-gray-100 transition-colors"
              aria-label="Toggle categories panel"
            >
              <FaBars className="text-gray-700 text-xl" />
            </button>
               :""}

            {/* Left Side Panel */}
            <div
              className={`absolute top-0 left-0 h-full bg-white shadow-2xl z-[1000] transition-transform duration-300 ease-in-out ${
                isPanelOpen ? 'translate-x-0' : '-translate-x-full'
              }`}
              style={{ width: '320px' }}
            >
              <div className="flex flex-col h-full">
                {/* Panel Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-800">Categories</h2>
                  <button
                    onClick={() => setIsPanelOpen(false)}
                    className="text-gray-500 hover:text-gray-800 transition-colors"
                    aria-label="Close panel"
                  >
                    <FaTimes className="text-xl" />
                  </button>
                </div>

                {/* Categories List */}
                <div className="flex-1 overflow-y-auto p-4">
                  {poiCategories?.length > 0 ? (
                    <div className="space-y-2">
                      {poiCategories?.map((category) => {
                        const categoryId = category.id || category.categoryId;
                        const isSelected = selectedCategory === categoryId;
                        return (
                          <div 
                            key={categoryId} 
                            className={`border rounded-lg transition-colors cursor-pointer ${
                              isSelected 
                                ? 'border-blue-500 bg-blue-50' 
                                : 'border-gray-200 hover:border-gray-300'
                            }`}
                            onClick={() => handleCategoryClick(categoryId)}
                          >
                            <div className="flex items-center p-3 hover:bg-gray-50 transition-colors rounded-lg cursor-pointer">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                readOnly
                                className="checkbox-custom w-4 h-4 bg-gray-100 dark:bg-white border-2 border-gray-300 dark:border-gray-400 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer pointer-events-none"
                              />
                              <span className={`ml-3 font-medium flex-1 ${
                                isSelected ? 'text-blue-700' : 'text-gray-700'
                              }`}>
                                {t(category?.name) || t(category?.categoryName) || 'Unnamed Category'}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="text-center text-gray-500 py-8">
                      <p>{t("no_categories")}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <StreetMapContainer
              markers={map}
              zoom={13}
              scrollWheelZoom={false}
              className="w-full h-full rounded-b-lg"
              style={{ height: "100%", width: "100%" }}
              showZoomControlProp={false}
              showZoomControl={true}
            />
          </div>
        ) : (
          <iframe
            src={url?.startsWith("http") ? url : `https://${url}`}
            title="Link Preview"
            className="w-full h-full rounded-b-lg border-0"
            onLoad={() => setIsLoading(false)}
          />
        )}
      </div>
    </div>
  );
};

export default ServiceViewModal;